module.exports = __webpack_public_path__ + "../resources/img/ic-re-check.d703700d.svg";